/**
 * 全局配置文件
 */
const domain = process.env.NODE_ENV === "development" ? "sdlandsea.net" : (window.location.href.indexOf("sdland-sea.com") > -1 || window.location.href.indexOf("i-mss.cn") > -1 ? "sdland-sea.com" : "sdlandsea.net");


export default {
  title: "多式联运供应链综合服务平台",
  key: "i-mss",

  // 单点登录退出地址
  LOGOUT_URL: `${location.protocol}//iam.${domain}/#/passport/logout?client_id=739102986378149888&response_type=code&redirect=true&redirect_uri=`,

  // 单点登录认证地址
  REQUEST_SPLICING_LH_SSO_BASE_URL: `${location.protocol}//iam.${domain}/#/passport/login?client_id=739102986378149888&response_type=code&redirect_uri=`,

  // 单点登录注册地址
  REGISTER_URL: `${location.protocol}//iam.${domain}/#/passport/register?client_id=739102986378149888&response_type=code&redirect_uri=`,

  // 单点登录codeCallback地址
  REQUEST_SPLICING_LH_SSO_CODE_CALLBACK: `${location.protocol}//${location.host}/codeCallback?redirect_uri=`,
};
